const currency = {
  getlist: 'currency/getlist',
  add: 'currency/add',
  update: 'currency/update',
  remove: 'currency/remove',
  get: 'currency/get',
  getall: 'currency/getall',
  clearcache: 'currency/clear-cache',
}
export default currency
